import gql from "graphql-tag";
export default gql`
  {
    oDEs {
      id
      name
    }
  }
`;
